import React from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import AboutUs from "../components/home/AboutUs";
import CarousselImg from "../components/home/CarousselImg";
import NavCase from "../components/home/NavCase";

const Home = () => {
  return (
    <div className="home">
      <Header />
      <CarousselImg />
      <NavCase />
      <AboutUs />
      <Footer />
    </div>
  );
};

export default Home;
